import gql from 'graphql-tag';
import { useQuery } from '@apollo/react-hooks';

import { PlanStack } from '@zapier/design-system-revenue/src/types';

export type Output = {
  error?: string;
  isLoading: boolean;
  planStacks: Array<PlanStack>;
};

export const defaultPlansQuery = gql`
  query defaultPlansQuery {
    pricingPageV3Plans {
      plans {
        amount
        id
        interval
        name
      }
      planType
    }
  }
`;

export const useDefaultPlans = (): Output => {
  const { data, error, loading } = useQuery(defaultPlansQuery);

  return {
    error: error ? 'Error loading plan information.' : undefined,
    isLoading: loading,
    planStacks: data?.pricingPageV3Plans ?? [],
  };
};
